import getConfig from 'next/config';
const { publicRuntimeConfig } = getConfig();

const ITR_UTM_REF = 'itr_2023_organic_landing_page_2';
const startFilingLink = `${publicRuntimeConfig.CLEARTAX_DOMAIN}/filing?utm_ref=${ITR_UTM_REF}`;
export const startFilingLinkViewPlans = `${publicRuntimeConfig.CLEARTAX_DOMAIN}/filing/?showplan=1&utm_ref=${ITR_UTM_REF}`;
export const cryptoIntegrationLink = `${publicRuntimeConfig.SSO_ENDPOINT}?product=crypto&utm_ref=crypto_itr_2_integration_page&return_path=L2NyeXB0by10YXgtZmlsaW5nL2Jyb2tlcnMv`;

const heroSection = {
  title: 'File ITR for capital gains in minutes ',
  lists: [
    'Auto-fill trading income',
    'Auto carry forward of past losses',
    'Simplified presumptive taxation',
  ],
  button: [
    {
      text: 'Start filing',
      url: startFilingLink,
    },
    {
      text: 'View plans',
    },
  ],
};

const whyChooseSection = {
  title: 'Why choose ClearTax',
  lists: [
    {
      title: 'Streamline ITR for All Business Incomes',
      desc: 'Simplest ITR process for businesses, Professionals, traders and Freelancers',
    },
    {
      title: 'Auto-Fill Income, Business & TDS',
      desc: 'Auto-retrieve income, business, and TDS details with one click using Form 26AS.',
    },
    {
      title: 'Hassle-Free F&O Turnover & Balance Sheets ',
      desc: 'Auto-calculate F&O turnover and fill balance sheets with ease in minutes',
    },
    {
      title: 'Automatic Carry Forward of Loss ',
      desc: 'Auto-fill previous year’s losses to reduce your current tax burden effortlessly.',
    },
  ],
  buttons: [
    {
      text: 'Start FIling',
      url: startFilingLink,
    },
  ],
};
export const ExchangeList = [
  {
    id: '1',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/718342aa-8b15-49d5-9d1a-45d1806e5c1e.png',
    name: 'Upstox',
  },
  {
    id: '2',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/db2e54bb-de91-464e-8814-060c807fc7c3.png',
    name: 'Kite',
  },
  {
    id: '3',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/3bc8bfe5-ea83-404c-b41e-8f5ea8d633e8.png',
    name: 'Groww',
  },
  {
    id: '4',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/4b73f019-0e78-4e20-a1c8-4b0798130b54.png',
    name: 'ICICI Direct',
  },
  {
    id: '5',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/e8ce47b3-1f4c-48c8-aece-129ab4c098ff.png',
    name: 'Paytm Money',
  },
  {
    id: '6',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/bb34b676-c260-4564-8789-353fa5cb6237.png',
    name: 'SBI Caps',
  },
  {
    id: '7',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/1a4f9afc-2d8e-4289-9190-04eed9f7a244.png',
    name: 'Kotak',
  },
  {
    id: '8',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/a965c566-85b4-4d76-b10a-687be311c652.png',
    name: 'Axis Securities',
  },
  {
    id: '9',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/734b28d5-91cf-4d68-8382-82209468c896.png',
    name: 'Reliance Securities',
  },
  {
    id: '10',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/d37ab44c-70e2-493b-8bbc-eed9dcc53534.png',
    name: 'Zerodha',
  },
  {
    id: '11',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/5937fd37-48df-404b-be2e-ed89f99e3a12.png',
    name: 'HDFC Securities',
  },
];

export const ExchangeList2 = [
  {
    id: '1',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675108712_wazirx_logo.png',
    name: 'WazirX',
  },
  {
    id: '2',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675109419_coindcx_logo.png',
    name: 'CoinDCX',
  },
  {
    id: '3',
    icon: 'https://assets1.cleartax-cdn.com/taxengine-crypto/images/1682491670_coinswitch.svg',
    name: 'CoinSwitch',
  },
  {
    id: '4',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675109376_binance_logo.png',
    name: 'Binance',
  },
  {
    id: '5',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675109827_coinbase_logo.png',
    name: 'Coinbase',
  },
  {
    id: '6',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675109384_bitbns_logo.png',
    name: 'BitBNS',
  },
  {
    id: '7',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675108721_zebpay__logo.png',
    name: 'Zebpay',
  },
  {
    id: '8',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675108642_metamask_logo.png',
    name: 'Metamask',
  },
  {
    id: '9',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675109568_etherium_logo.png',
    name: 'Etherium',
  },
  {
    id: '10',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675108612_kucoin_logo.png',
    name: 'KuCoin',
  },
  {
    id: '11',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675108657_solana_logo.png',
    name: 'Solana',
  },
  {
    id: '10',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675108612_kucoin_logo.png',
    name: 'KuCoin',
  },
  {
    id: '11',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675108657_solana_logo.png',
    name: 'Solana',
  },
];

export const itrData = {
  heroSection,
  isVariant: false,
  whyChooseSection,
};

export const GuidesAndLinksDataITR2 = {
  heading: 'Guides and useful links to help you Efile taxes',
  cards: [
    {
      label: 'Presumptive Taxation',
      description: `Businesses and Professionals can opt for presumptive taxation where income is computed as a percentage of the turnover.`,
      link: 'https://cleartax.in/s/freelance-professional-business-income',
    },
    {
      label: 'Presumptive Taxation for Businesses',
      description: `Businesses opting for presumptive taxation have the option to declare income at 8% of their turnover. Know the applicable threshold limit.`,
      link: 'https://cleartax.in/s/section-44ad-presumptive-scheme',
    },
    {
      label: 'Presumptive Taxation for Professionals',
      description: `Professionals can opt for the presumptive taxation scheme and declare profits at 50% of their turnover.`,
      link: 'https://cleartax.in/s/section-44ada',
    },
    {
      label: 'Which ITR to file?',
      description: `Know which ITR is applicable for taxpayers opting for Presumptive Taxation. Filing the right ITR form is crucial to avoid notices from the tax department.`,
      link: 'https://cleartax.in/s/which-itr-to-file',
    },
    {
      label: 'What Is ITR-3?',
      description: `Taxpayers with business and professional income exceeding Rs. 50 lakh need to file Form ITR-3. Both audit and non-audit taxpayers can file ITR-3.`,
      link: 'https://cleartax.in/s/itr3',
    },
    {
      label: 'What Is ITR-4?',
      description: `Taxpayers with business or professional income and opting for presumptive taxation need to file ITR-4 if their total income does not exceed Rs. 50 lakh.`,
      link: 'https://cleartax.in/s/itr4',
    },
    {
      label: 'Income Tax Audit',
      description: `Taxpayers whose turnover exceeds the threshold limit are required to conduct tax audit before filing their ITR. Taxpayers required to go through audit cannot opt for presumptive taxation.`,
      link: 'https://cleartax.in/s/tax-audit-section-44ab',
    },
    {
      label: 'Income Tax Slabs',
      description: `Taxpayers with business and professional income need to pay tax at their applicable income tax slab rate. It is important to under the tax slabs and opt for the best tax regime.`,
      link: 'https://cleartax.in/s/income-tax-slabs',
    },
  ],
};

export const ITR_2_FAQs = [
  {
    header:
      'As a professional (Doctor, Lawyer, Tutor, Influencer), can I claim expenses against my income?',
    content: (
      <>
        <p>
          Yes, professionals can claim business expenses such as office rent,
          utilities, salary of staff, marketing costs, and other expenses
          directly related to their profession under Section 37(1). However,
          personal expenses are not deductible
        </p>
      </>
    ),
  },
  {
    header: 'How do I report profits from F&O or Intraday trading in my ITR?',
    content: (
      <p>
        Profits from F&O and Intraday trading are treated as business income and
        must be reported under &quot;Income from Business or Profession&quot; in
        ITR-3. You need to maintain a profit and loss statement and disclose
        turnover, which is calculated based on the total of positive and
        negative trades in a financial year.
      </p>
    ),
  },
  {
    header:
      'Can I claim losses from F&O trading or Intraday trading to offset my other income?',
    content: (
      <p>
        Yes, losses from F&O and Intraday trading can be carried forward for up
        to 8 years, and you can set off the losses against future business
        profits or other capital gains, subject to filing your return on time.
        Make sure to report them accurately in your ITR.
      </p>
    ),
  },
  {
    header:
      'As a freelancer, can I claim deductions for my work-related expenses?',
    content: (
      <p>
        Yes, as a freelancer, you can claim deductions for expenses related to
        your work, such as office supplies, software subscriptions, travel,
        marketing, and home office expenses, under Section 37(1). Ensure proper
        documentation for claiming these deductions.
      </p>
    ),
  },
  {
    header:
      'How do I report income from a partnership firm, and what tax implications should I be aware of?',
    content: (
      <p>
        As a partner in a firm, your share of profits is considered business
        income and should be reported in your ITR under &quot;Income from
        Business or Profession.&quot; If the firm pays tax under the Partnership
        Tax Regime (Section 44AD or 44ADA), you need to report your share of
        profits and the tax paid by the firm. If the firm has losses, you can
        only claim the share of profits from the firm and not the losses.
      </p>
    ),
  },
];
